import { loadStores } from "../../components/stores/StoreLoader";
import {
  ExecutionEnvironment,
  isServerComponent,
} from "../../components/stores/InterfaceStore";
import { use } from "react";
import { StoreContext } from "./StoreContext";
import { readContext } from "react-server-only-context";
import { InitialLookupDataContext } from "./InitialLookupDataContext";

export function useStores() {
  if (ExecutionEnvironment.canUseDOM || !isServerComponent) {
    // We are in the DOM or SSR in a client component, so we can use context
    return use(StoreContext);
  } else if (isServerComponent) {
    // If inside a server component, we want to return the cached response of loadStores()
    const initialLookupData = readContext(InitialLookupDataContext);
    return loadStores(initialLookupData);
  }
}
